export default __webpack_public_path__ + "static/media/Laser_0000_Big-laser-body.43d0c44f.png";